module.exports = __webpack_public_path__ + "img/crSD.82345a31.svg";